/**
 * Operation types for the search outbox.
 * Determines what action the background worker performs on the OpenSearch index.
 */
export const SearchOutboxOperation = {
    /** Index a new document */
    CREATE: 'CREATE',
    /** Update an existing document */
    UPDATE: 'UPDATE',
    /** Remove a document from the index */
    DELETE: 'DELETE',
};
/**
 * Status values for search outbox entries.
 * Tracks the lifecycle of each outbox entry as it moves through processing.
 */
export const SearchOutboxStatus = {
    /** Entry is waiting to be processed */
    PENDING: 'PENDING',
    /** Entry is currently being processed by a worker */
    PROCESSING: 'PROCESSING',
    /** Entry was successfully synced to OpenSearch */
    PROCESSED: 'PROCESSED',
    /** Entry failed to sync after exhausting retries */
    FAILED: 'FAILED',
};
/** Maximum number of retry attempts before marking an entry as FAILED. */
export const OUTBOX_MAX_RETRIES = 5;
/** Default batch size when polling for pending outbox entries. */
export const OUTBOX_DEFAULT_BATCH_SIZE = 50;
/**
 * OpenSearch index names used in the application.
 */
export const OPENSEARCH_INDICES = {
    LEGISLATIVE_ITEMS: 'legislative_items',
    PUBLIC_DOCUMENTS: 'public_documents',
    MEETING_TRANSCRIPTS: 'meeting_transcripts',
};
